var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 19.95",
    fill: "currentColor",
    enableBackground: "new 0 0 35 19.95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.107c0.159-0.616,0.417-1.168,0.935-1.579c0.87-0.692,2.135-0.709,3.006-0.015 c0.169,0.134,0.328,0.283,0.48,0.436c4.255,4.253,8.509,8.508,12.762,12.764c0.096,0.096,0.174,0.211,0.411,0.387 c0.067-0.12,0.111-0.263,0.204-0.357c4.291-4.298,8.587-8.591,12.879-12.888c0.758-0.759,1.635-1.051,2.677-0.719 c1.526,0.487,2.147,2.445,1.187,3.728c-0.109,0.145-0.228,0.285-0.357,0.414c-4.946,4.949-9.892,9.897-14.841,14.842 c-0.904,0.903-2.051,1.082-3.082,0.475c-0.251-0.148-0.475-0.355-0.683-0.563c-4.805-4.799-9.604-9.605-14.413-14.4 C0.633,4.1,0.157,3.551,0,2.791C0,2.563,0,2.335,0,2.107z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.5b543fcf4fcd9b7326b4b2f9c5095608.svg";
export { ForwardRef as ReactComponent };